var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type!=='loading')?_c('i',{class:("ipub-icon iconfont " + (this.type)),on:{"click":_vm.handleClick}}):_c('i',{class:"ipub-loading ipub-icon iconfont iconLoading"})}
var staticRenderFns = []

export { render, staticRenderFns }